export enum PopoverTabIndex {
  Clients,
  Advertisers,
}
